import { ThemeUICSSObject, responsive, spacing } from '@apia/theme';
import topBox from './topBox';

const twoColumnsListOneColumnAside: ThemeUICSSObject = {
  display: 'flex',
  flexDirection: 'column',

  maxWidth: 'calc(100vw)',

  mx: 'auto',
  gap: spacing(3),
  px: 3,

  overflow: 'hidden',
  height: '100vh',

  '.twoColumnsList__topBox': topBox,

  '&.maximized': {
    '.twoColumnsList__section': {
      '.twoColumnsList__aside': {
        display: 'none',
      },
    },
    '.twoColumnsList__topBox': {
      '.topBox__heading': {
        '.topBox__nav': {
          display: 'flex',
          '.HamburguerIconWrapper': {
            '&:not(.forced)': {
              display: responsive({ 0: 'none', 3: 'flex' }),
            },
          },
        },
      },
    },
  },

  '.twoColumnsList__section': {
    display: 'flex',
    gap: spacing(3),
    alignItems: 'stretch',
    flexGrow: 1,
    overflow: 'hidden',

    '.twoColumnsList__main': {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(3),
      height: '100%',
      overflow: 'hidden',
      maxHeight: '100%',

      '.twoColumnsList__content ': {
        flexGrow: 1,
        overflow: 'auto',
        maxHeight: '100%',
        background: 'palette.background.paper',

        '.selection__keyHandler': {
          height: '100%',

          '.responsiveTable__wrapper': {
            height: '100%',
          },
        },
      },

      '.twoColumnsList__contentFooter': {
        flexShrink: 0,
        flexGrow: 0,
        position: 'relative',
      },

      '#AccordionAside': {
        display: responsive({ 0: 'block', 3: 'none' }),

        '.asidePanel__content': {
          paddingTop: spacing(3),
        },
        '.content': {
          background: 'palette.background.paper',
          overflow: ' auto',
          maxHeight: '90vh',

          '.ApplicationMenu': {
            mx: 'auto',
            py: responsive({ 0: 4, 2: 7 }),
            px: responsive({ 0: 4, 2: 0 }),
          },
        },
      },
    },

    '.twoColumnsList__aside': {
      width: '150px',
      flexShrink: 0,
      flexGrow: 0,
      overflow: 'auto',
      maxHeight: '100%',

      display: responsive({ 0: 'none', 4: 'flex' }),
      flexDirection: 'column',

      alignItems: 'stretch',
      justifyContent: 'stretch',

      '& > div': {
        height: '100%',

        '.ApplicationMenu': {
          height: '100%',
          pb: '3px',
        },
      },
    },
  },

  '#FloatingOptions': {
    display: 'none',
  },
};

export default twoColumnsListOneColumnAside;
